export default __webpack_public_path__ + "static/media/certificate-valid.6e8564be.svg";